"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[896],{

/***/ 2896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zW": function() { return /* binding */ Events; },
  "sn": function() { return /* binding */ PageNames; },
  "c7": function() { return /* binding */ PageTypes; },
  "Vk": function() { return /* binding */ handleAccountPageEvent; },
  "qH": function() { return /* binding */ handleHomePageEvent; },
  "GV": function() { return /* binding */ handleTrackEvent; },
  "jV": function() { return /* binding */ mountDataLayer; },
  "l9": function() { return /* binding */ setPageAnalyticsData; }
});

// UNUSED EXPORTS: EventTypes, generatePageName

// EXTERNAL MODULE: ./node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(5501);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@segment/snippet/lib/index.js
var lib = __webpack_require__(2913);
;// CONCATENATED MODULE: ./lib/analytics/asyncScriptLoader.ts
var createElement = function() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    return script;
};
var injectScripUrl = function() {
    var scriptUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    if (!scriptUrl) {
        console.warn('you need to pass the script url!!!');
        return false;
    }
    var elem = createElement();
    elem.async = true;
    elem.src = scriptUrl;
    document.body.appendChild(elem);
    return new Promise(function(resolve) {
        elem.onload = function() {
            resolve({
                loaded: true
            });
        };
    });
};
var injectScriptSrc = function() {
    var scriptSrc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    if (!scriptSrc) {
        console.warn('you need to pass the script source!!!');
        return false;
    }
    var elem = createElement();
    elem.text = scriptSrc;
    document.body.appendChild(elem);
    return Promise.resolve({
        loaded: true
    });
};
function asyncScriptLoader_inject(scriptUrl, scriptSrc) {
    if (!scriptUrl && !scriptSrc) {
        console.warn('please pass a script url or src');
    }
    return scriptUrl ? injectScripUrl(scriptUrl) : injectScriptSrc(scriptSrc);
}

;// CONCATENATED MODULE: ./lib/analytics/queue.ts
var queue_queue = function() {
    var storage = []; // this could be local storage / indexed db for offline analytics
    var push = function(param) {
        var eventName = param.eventName, props = param.props, context = param.context, _eventType = param.eventType, eventType = _eventType === void 0 ? 'track' : _eventType;
        return storage.push({
            eventName: eventName,
            props: props,
            context: context,
            eventType: eventType
        });
    };
    var remove = function() {
        return storage.shift();
    };
    var removeAll = function() {
        storage.length = 0;
        return true;
    };
    var length = function() {
        return storage.length;
    };
    var isEmpty = function() {
        return !storage.length;
    };
    var getAll = function() {
        return storage;
    };
    return {
        push: push,
        remove: remove,
        length: length,
        getAll: getAll,
        removeAll: removeAll,
        isEmpty: isEmpty
    };
}();
/* harmony default export */ var analytics_queue = ((/* unused pure expression or super */ null && (queue_queue)));

// EXTERNAL MODULE: ./lib/utils/index.ts + 2 modules
var utils = __webpack_require__(4038);
// EXTERNAL MODULE: ./lib/utils/configs.ts
var configs = __webpack_require__(2670);
;// CONCATENATED MODULE: ./lib/analytics/segment/index.ts







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var EventTypes;
(function(EventTypes) {
    EventTypes["PAGE"] = 'page';
    EventTypes["TRACK"] = 'track';
})(EventTypes || (EventTypes = {}));
var scriptSrc = " !function(){var analytics=window.analytics=window.analytics||[];\n  if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error(\"Segment snippet included twice.\");\n  else{analytics.invoked=!0;analytics.methods=[\"trackSubmit\",\"trackClick\",\"trackLink\",\"trackForm\",\"pageview\",\"identify\",\"reset\",\"group\",\"track\",\"ready\",\"alias\",\"debug\",\"page\",\"once\",\"off\",\"on\",\"addSourceMiddleware\",\"addIntegrationMiddleware\",\"setAnonymousId\",\"addDestinationMiddleware\"];\n  analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement(\"script\");t.type=\"text/javascript\";\n  t.async=!0;t.src=\"https://cdn.segment.com/analytics.js/v1/\" + key + \"/analytics.min.js\";var n=document.getElementsByTagName(\"script\")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey=\"YOUR_WRITE_KEY\";analytics.SNIPPET_VERSION=\"4.13.2\";\n  analytics.load(\"".concat(utils/* analyticsConfig.segmentKey */.Aj.segmentKey, "\");\n  analytics.page();\n  analytics.ready(segmentFlushQueue);\n  }}();");
function init() {
    return _init.apply(this, arguments);
}
function _init() {
    _init = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return retry();
                case 2:
                    return _ctx.abrupt("return", inject('', scriptSrc));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _init.apply(this, arguments);
}
var renderSnippet = function() {
    var opts = {
        apiKey: analyticsConfig.segmentKey,
        page: false
    };
    if ((profileConfig === null || profileConfig === void 0 ? void 0 : profileConfig.ENVIRONMENT) === 'development') {
        return snippet.max(opts);
    }
    return snippet.min(opts);
};
var wait = function(delay) {
    return new Promise(function(resolve) {
        return setTimeout(function() {
            return resolve(true);
        }, delay);
    });
};
var retry = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
        var attempts, delay, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    attempts = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 0, delay = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 1500;
                    _ctx.next = 3;
                    return wait(delay);
                case 3:
                    if (!isLoaded()) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 5:
                    if (!(attempts >= 2)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 7:
                    asyncScriptLoader_inject('', scriptSrc);
                    attempts += 1;
                    return _ctx.abrupt("return", retry(attempts, delay));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function retry() {
        return _ref.apply(this, arguments);
    };
}();
var isLoaded = function() {
    return !!window.analytics;
};
var segment_flushQueue = function() {
    var ref;
    var tracksStorage = (ref = queue.getAll()) !== null && ref !== void 0 ? ref : [];
    tracksStorage.forEach(function(item) {
        fireEvent(item);
        queue.remove();
    });
};
var fireEvent = function(param) {
    var _eventName = param.eventName, eventName = _eventName === void 0 ? '' : _eventName, _props = param.props, props = _props === void 0 ? {} : _props, _context = param.context, context = _context === void 0 ? {} : _context, _eventType = param.eventType, eventType = _eventType === void 0 ? 'track' : _eventType;
    if ((0,utils/* trimLowerCase */.hG)(eventType) === EventTypes.PAGE) {
        window.analytics && window.analytics.page(eventName, props, context);
    } else if ((0,utils/* trimLowerCase */.hG)(eventType) === EventTypes.TRACK) window.analytics && window.analytics.track(eventName, props, context);
};
var segmentTrackEvent = function(param) {
    var eventName = param.eventName, props = param.props, context = param.context, eventType = param.eventType;
    fireEvent({
        eventName: eventName,
        props: props,
        eventType: eventType,
        context: context
    });
};

;// CONCATENATED MODULE: ./lib/analytics/index.ts

var initiated = false;
var LCP_TIME = 6000;
var analytics_init = function() {
    window.segmentFlushQueue = flushQueue;
    if (initiated) return true;
    initSegment();
    initiated = true;
    window.addEventListener('unload', function() {
        flushQueue();
    });
    return initiated;
};
var handleAnalytics = function(event) {
    segmentTrackEvent(event);
};
var timedOutInit = function() {
    if (initiated) return true;
    setTimeout(function() {
        return analytics_init();
    }, LCP_TIME);
    return true;
};

// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/utils/getConfig.ts + 1 modules
var getConfig = __webpack_require__(889);
;// CONCATENATED MODULE: ./lib/analytics/trackCalls.ts





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var trackCalls_EventTypes;
(function(EventTypes) {
    EventTypes["PAGE"] = 'page';
    EventTypes["TRACK"] = 'track';
})(trackCalls_EventTypes || (trackCalls_EventTypes = {}));
var Events;
(function(Events) {
    Events["BUTTON_LINK_SELECTED"] = 'Button Link Selected';
    Events["SUBMIT"] = 'Submit';
    Events["SUBMIT_CODE_LANDING"] = 'Submit Code Landing';
    Events["SUBMIT_CODE_STARTED"] = 'Submit Code Started';
    Events["SUBMIT_CODE_COMPLETED"] = 'Submit Code Completed';
    Events["PROFILE_ACCESS_ACTIVATION_STARTED"] = 'Profile Access Activation Started';
    Events["PROFILE_ACCESS_ACTIVATION_COMPLETED"] = 'Profile Access Activation Completed';
    Events["PROFILE_ACCESS_ACTIVATION_ERROR"] = 'Profile Access Activation Error';
    Events["PROFILE_INITIATED"] = 'Profile Initiated';
    Events["PROFILE_PROMPT_LANDING"] = 'Profile Prompt Landing';
    Events["PROFILE_SIGN_IN_STARTED"] = 'Profile Sign In Started';
    Events["PROFILE_SIGN_UP_STARTED"] = 'Profile Sign Up Started';
    Events["PROFILE_SIGN_IN_COMPLETED"] = 'Profile Sign In Completed';
    Events["PROFILE_SIGN_UP_COMPLETED"] = 'Profile Sign Up Completed';
})(Events || (Events = {}));
var SPORT_PREFIX = 'nation sport';
var PageNames;
(function(PageNames) {
    PageNames["SUBMIT_CODE_LANDING"] = 'submit code landing';
    PageNames["PROFILE_PROMPT_LANDING"] = 'profile prompt:landing';
})(PageNames || (PageNames = {}));
var PageTypes;
(function(PageTypes) {
    PageTypes["ACTIVATION_CODE"] = 'activation code';
    PageTypes["PROFILE_PROMPT"] = 'profile prompt';
})(PageTypes || (PageTypes = {}));
var getClientPrefix = _defineProperty({}, constants/* Brand.SPORTS */.H2.SPORTS, SPORT_PREFIX);
var ACTIVATION_METHOD = '2nd screen';
var APP_PLATFORM = 'web';
var FOX = 'fox';
var FOX_DOMAIN = 'fox.com';
var NATION_DOMAIN = 'foxnews.com';
var ANONYMOUS_ID_COOKIE = 'lastAnonymousProfileId';
var PAGE_TYPE = 'ott';
var PRIMARY_BUSINESS_UNIT = 'fng';
var PROFILE_ID_COOKIE = 'secondScreenProfileId';
var START_SOURCE = 'general';
var APP_CLIENT_PREFIX = getClientPrefix[constants/* Brand.SPORTS */.H2.SPORTS];
var defaultTraits = {
    appsflyer_id: '',
    dcg_profile_id: '',
    lastAnonymousProfileId: '',
    lastKnownProfileId: '',
    mvpd: '',
    network_entitlement_list: '',
    us_privacy: ''
};
// TODO: Update BRAND and DEVICE for Nation
// const DEVICE = account?.device ?? 'FOX';
var BRAND = FOX;
var DEVICE = 'FOX';
var defaultProps = {
    app_name: constants/* Brand.SPORTS */.H2.SPORTS || BRAND,
    app_platform: APP_PLATFORM,
    // TODO: set app version dynamically
    app_version: '1.0.0',
    page_name: ACTIVATION_METHOD,
    page_profile_activation_method: ACTIVATION_METHOD,
    page_start_source: START_SOURCE,
    page_type: PAGE_TYPE,
    primary_business_unit: PRIMARY_BUSINESS_UNIT,
    secondary_business_unit: constants/* Brand.SPORTS */.H2.SPORTS || BRAND
};
var handleTrackEvent = function() {
    for(var _len = arguments.length, events = new Array(_len), _key = 0; _key < _len; _key++){
        events[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _step.value, eventName = _value.eventName, props = _value.props, context = _value.context, eventType = _value.eventType;
            var ref, ref1;
            var cookies = new Cookies/* default */.Z();
            var ref2;
            var profileId = (ref2 = cookies.get(PROFILE_ID_COOKIE)) !== null && ref2 !== void 0 ? ref2 : '';
            var ref3;
            var codeInfoCookie = (ref3 = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref3 !== void 0 ? ref3 : {};
            var campaignCodes = fetchCampaignCodes();
            // TODO: Find out why campaignCodes are different for different events
            if (eventName === Events.PROFILE_ACCESS_ACTIVATION_COMPLETED) {
                var ref4;
                var compaignCodesCookie = (ref4 = cookies.get(constants/* COOKIE_CAMPAIGN_CODES */.gV)) !== null && ref4 !== void 0 ? ref4 : '';
                campaignCodes = parseCampaignParams(compaignCodesCookie);
            }
            var traits = _objectSpread({}, defaultTraits, campaignCodes, {
                dcg_profile_id: profileId,
                lastAnonymousProfileId: getAnonymousId(),
                lastKnownProfileId: profileId
            });
            var ref5;
            var argsPageName = (ref5 = props === null || props === void 0 ? void 0 : props.page_name) !== null && ref5 !== void 0 ? ref5 : null;
            var ref6;
            var currentPageName = (ref6 = (ref = window.DataLayer) === null || ref === void 0 ? void 0 : ref.page_name) !== null && ref6 !== void 0 ? ref6 : null;
            var pageName = argsPageName !== null && argsPageName !== void 0 ? argsPageName : currentPageName;
            var genericPageName = generatePageName({
                pageName: pageName
            });
            var ref7;
            var argsPageType = (ref7 = props === null || props === void 0 ? void 0 : props.page_type) !== null && ref7 !== void 0 ? ref7 : null;
            var ref8;
            var currentPageType = (ref8 = (ref1 = window.DataLayer) === null || ref1 === void 0 ? void 0 : ref1.page_type) !== null && ref8 !== void 0 ? ref8 : null;
            var pageType = argsPageType !== null && argsPageType !== void 0 ? argsPageType : currentPageType;
            var ref9;
            var argsActivationCode = (ref9 = props === null || props === void 0 ? void 0 : props.page_activation_code) !== null && ref9 !== void 0 ? ref9 : null;
            var _code;
            var currentActiovationCode = (_code = codeInfoCookie.code) !== null && _code !== void 0 ? _code : null;
            var activationCode = argsActivationCode !== null && argsActivationCode !== void 0 ? argsActivationCode : currentActiovationCode;
            var newContext = _objectSpread({}, context, {
                traits: traits
            });
            var finalProps = (0,helper.cleanObject)(_objectSpread({}, defaultProps, {
                page_name: genericPageName,
                page_type: pageType,
                page_activation_code: activationCode
            }, props));
            handleAnalytics({
                eventName: eventName,
                props: finalProps,
                eventType: eventType,
                context: newContext
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var generatePageName = function(param) {
    var pageName = param.pageName;
    return "".concat(APP_CLIENT_PREFIX, ":").concat(APP_PLATFORM, ":").concat(pageName);
};
var handleHomePageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_ACCESS_ACTIVATION_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_LANDING,
        eventType: trackCalls_EventTypes.PAGE
    });
};
var handleAccountPageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_PROMPT_LANDING,
        eventType: trackCalls_EventTypes.PAGE
    });
};
var getAnonymousId = function() {
    var ref;
    var cookies = new Cookies/* default */.Z();
    var user = (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.user;
    var ref10;
    var lastAnonymousProfileId = (ref10 = cookies.get(ANONYMOUS_ID_COOKIE)) !== null && ref10 !== void 0 ? ref10 : '';
    var networkDomain;
    if (BRAND === FOX) networkDomain = FOX_DOMAIN;
    else networkDomain = NATION_DOMAIN;
    if (lastAnonymousProfileId) {
        cookies.set(ANONYMOUS_ID_COOKIE, lastAnonymousProfileId, {
            domain: networkDomain
        });
        return lastAnonymousProfileId;
    }
    var anonymousId = user ? user().anonymousId() : null;
    // TODO: Finds out why it is here
    cookies.set(ANONYMOUS_ID_COOKIE, anonymousId, {
        domain: networkDomain
    });
    return anonymousId;
};
var mountDataLayer = function() {
    window.DataLayer = {};
};
var setPageAnalyticsData = function(param) {
    var pageName = param.pageName, pageType = param.pageType;
    if (!window.DataLayer) mountDataLayer();
    window.DataLayer.page_name = pageName;
    window.DataLayer.page_type = pageType;
};
var parseCampaignParams = function(queryString) {
    if (!queryString) return {};
    var cleanQueryString = queryString.split('undefinedUnknown')[0];
    var segmentCampaign = 'cmpid';
    var propertyNames = {
        cmpid: 'campaign_int_tracking_code',
        int_cmp: 'campaign_int_name'
    };
    var params = {};
    var ref13;
    var cleanCampaignString = (ref13 = cleanQueryString.match(/^[^&]*/)) !== null && ref13 !== void 0 ? ref13 : '';
    var ref11;
    var campaignString = (ref11 = cleanCampaignString[0]) !== null && ref11 !== void 0 ? ref11 : '';
    params[propertyNames[segmentCampaign]] = campaignString;
    var campaignCodes = campaignString.split('::');
    (campaignCodes || []).forEach(function(codes) {
        var keyValuesPair = codes.split('=');
        if (keyValuesPair.length === 2) {
            var ref;
            var key = (ref = keyValuesPair[0]) !== null && ref !== void 0 ? ref : '';
            var ref12;
            var value = (ref12 = keyValuesPair[1]) !== null && ref12 !== void 0 ? ref12 : '';
            var _key;
            var property = (_key = propertyNames[key]) !== null && _key !== void 0 ? _key : '';
            params[property] = value;
        }
    });
    return (0,helper.cleanObject)(params);
};
var fetchCampaignCodes = function() {
    var ref;
    var intCmp = (ref = getParameterByName(constants/* INT_CMP */.vl)) !== null && ref !== void 0 ? ref : null;
    // if (intCmp == null) return null;
    var intOrg = 'dcg';
    // TODO: Get brand from
    var intMc = BRAND;
    var ref14;
    var intSrc = (ref14 = getDeviceFromProvidersByKey()) !== null && ref14 !== void 0 ? ref14 : DEVICE;
    var intAdd = intMc + (intSrc ? '_' + intSrc : '') + (intCmp ? '_' + intCmp : '');
    var codes = (0,helper.cleanObject)({
        int_org: intOrg,
        int_mc: intMc !== null && intMc !== void 0 ? intMc : null,
        int_src: intSrc !== null && intSrc !== void 0 ? intSrc : null,
        int_cmp: intCmp !== null && intCmp !== void 0 ? intCmp : null,
        int_add: intAdd !== null && intAdd !== void 0 ? intAdd : null
    });
    codes.campaign_int_tracking_code = formatCampaignString(codes);
    return codes;
};
var getParameterByName = function getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window === null || window === void 0 ? void 0 : window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};
var formatCampaignString = function(campaignCodes) {
    var campaignKeys = Object.keys(campaignCodes);
    return campaignKeys.reduce(function(acc, key, i) {
        var isLast = i === campaignKeys.length - 1;
        return acc + key + '=' + campaignCodes[key] + (!isLast ? '::' : '');
    }, '');
};
var getDeviceFromProvidersByKey = function() {
    var cookies = new Cookies/* default */.Z();
    var ref;
    var codeInfoCookie = (ref = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref !== void 0 ? ref : '';
    var config = (0,getConfig/* getConfig */.i)();
    var ref15;
    var devices = (ref15 = config === null || config === void 0 ? void 0 : config.devices) !== null && ref15 !== void 0 ? ref15 : [];
    Object.entries(devices).forEach(function(element) {
        var deviceName = element[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var providerKeys = element[1]['providers-key'];
        if (providerKeys === codeInfoCookie || deviceName === providerKeys) return element;
    });
    return null;
};


/***/ }),

/***/ 6637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_utils_logReportHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1184);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getRegCodeResponse = function() {
    var _ref = _asyncToGenerator(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(options, profile) {
        var ref, responseError;
        return _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return profile === null || profile === void 0 ? void 0 : (ref = profile.getAccountRegCode) === null || ref === void 0 ? void 0 : ref.call(profile, options);
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    responseError = 'Account RegCode Error';
                    (0,lib_utils_logReportHelper__WEBPACK_IMPORTED_MODULE_1__/* .logError */ .H)(_ctx.t0, {
                        name: responseError
                    });
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getRegCodeResponse(options, profile) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (getRegCodeResponse);


/***/ }),

/***/ 4038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aj": function() { return /* reexport */ configs/* analyticsConfig */.Aj; },
  "_y": function() { return /* reexport */ helper; },
  "z3": function() { return /* reexport */ messageConverter; },
  "CL": function() { return /* reexport */ configs/* setUpdatedProfile */.CL; },
  "hG": function() { return /* reexport */ trimLowerCase; }
});

// UNUSED EXPORTS: config, getConfig, getMvpds, getProfileSdkResponse, getRegCodeResponse, profileConfig, useSetUserLoggedInOrRegistered

// EXTERNAL MODULE: ./lib/utils/configs.ts
var configs = __webpack_require__(2670);
;// CONCATENATED MODULE: ./lib/utils/string.ts
var trimLowerCase = function(value) {
    return value ? value.replace(/ /g, '').toLowerCase() || '' : '';
};
var messageConverter = function(message, language_strings_en_US) {
    switch(message){
        case 'Invalid LoginId':
            return language_strings_en_US === null || language_strings_en_US === void 0 ? void 0 : language_strings_en_US.profile_passwordInvalidError;
        case 'Invalid parameter value':
            return language_strings_en_US === null || language_strings_en_US === void 0 ? void 0 : language_strings_en_US.profileCreate_invalidEmailText;
        default:
            break;
    }
    return message;
};

// EXTERNAL MODULE: ./lib/utils/getConfig.ts + 1 modules
var getConfig = __webpack_require__(889);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./lib/utils/logReportHelper.ts
var logReportHelper = __webpack_require__(1184);
;// CONCATENATED MODULE: ./lib/utils/getMvpds.ts


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getMvpds = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(profile, val) {
        var ref, responseError;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return profile === null || profile === void 0 ? void 0 : (ref = profile.getMvpds) === null || ref === void 0 ? void 0 : ref.call(profile, {
                        itemsPerPage: val
                    });
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    responseError = 'Profile get MVPD error';
                    (0,logReportHelper/* logError */.H)(_ctx.t0, {
                        name: responseError
                    });
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getMvpds(profile, val) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var utils_getMvpds = ((/* unused pure expression or super */ null && (getMvpds)));

// EXTERNAL MODULE: ./lib/utils/getProfileSdkResponse.ts
var getProfileSdkResponse = __webpack_require__(6357);
// EXTERNAL MODULE: ./lib/utils/getRegCodeResponse.ts
var getRegCodeResponse = __webpack_require__(6637);
// EXTERNAL MODULE: ./lib/utils/useSetUserLoggedInOrRegistered.ts
var useSetUserLoggedInOrRegistered = __webpack_require__(3860);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var helper = __webpack_require__(9981);
;// CONCATENATED MODULE: ./lib/utils/index.ts











/***/ })

}]);